<template>
    <div class="toast mw-100" role="alert" data-autohide="false" aria-live="assertive" aria-atomic="true"
         :class="{'chat-toast-customer': comment.customer, 'chat-toast-consultant': !comment.customer}">
        <div class="toast-header">
            <strong class="mr-auto">{{ comment['author'] }}</strong>
            <small>{{ time }}</small>
        </div>
        <div class="toast-body">
            <strong v-if="comment['valid'] ==true" class="font-italic d-block mb-2">{{ status_name }}</strong>
            <p v-if="!comment['html']" class="text-break" style="white-space: pre-wrap">{{ comment['content'] }}</p>
            <p v-else class="text-break" style="white-space: pre-wrap" v-html="comment['content']"></p>
        </div>
    </div>
</template>

<script>
$(document).ready(function () {
    const toast = $('.toast').toast('show');
});

export default {
    name: "toast-comment",
    props: [
        'comment',
        'status_name',
        'time'
    ],
    data() {
        return {
            badge: 'badge badge-' + this.comment['status'],
        }
    },

}
</script>

<style scoped>
/*.chat-toast-customer {*/
/*    margin-right: 500px;*/
/*}*/
/*.chat-toast-consultant{*/
/*    margin-left: 500px;*/
/*}*/
</style>
